import firebase from "firebase";
import "firebase/auth";
import { AnswerTypes } from "../model/index";
import { message } from "antd";

const config = {
	apiKey: "AIzaSyAD1rf1fAQaQEyFOIK8CJs_W_J4Z4HDygM",
	authDomain: "storpublic-91a3b.firebaseapp.com",
	databaseURL: "https://storpublic-91a3b.firebaseio.com",
	projectId: "storpublic-91a3b",
	storageBucket: "storpublic-91a3b.appspot.com",
	messagingSenderId: "630616714205",
};

const configTest = {
	apiKey: "AIzaSyCOUC3QoITmE83Nk0Mym2t_vV7ESvnQ-gY",
	authDomain: "stogpublictest.firebaseapp.com",
	databaseURL: "https://stogpublictest.firebaseio.com",
	projectId: "stogpublictest",
	storageBucket: "stogpublictest.appspot.com",
	messagingSenderId: "873912575803"
};

const keys = {
	result: "result",
	answers: "answers",
	questions: "questions",
	survey: "survey",
	users: "users",
	orders: "orders",
	feedback: "feedback"
};

const ref = val => firebase.database().ref(val);
const once = async val => await ref(val).once("value").then(snapshot => snapshot.val());
const auth = () => firebase.auth();

export async function init() {
	if (firebase.apps.length === 0) {
		if (process.env.NODE_ENV === "production" && !window.location.host.includes("stogpublictest")) {
			return firebase.initializeApp(config);
		}
		else {
			return firebase.initializeApp(configTest);
		}
	}
}

export const authUpdate = () => callback => auth().onAuthStateChanged(auth => callback({ auth }));

export const signOut = () => auth().signOut();

export async function sendPasswordResetEmail({ email }) {
	try {
		return await auth().sendPasswordResetEmail(email);
	} catch (error) {
		const errorCode = error.code;
		const errorMessage = error.message;
		if (errorCode === "auth/wrong-password") {
			message.error("Wrong email.");
		} else {
			message.error(errorMessage);
		}
		return null;
	}
}

export async function createUserWithEmailAndPassword({ email, password }) {
	try {
		return await auth().createUserWithEmailAndPassword(email, password);
	} catch (error) {
		const errorCode = error.code;
		const errorMessage = error.message;
		if (errorCode === "auth/wrong-password") {
			message.error("Wrong password.");
		} else {
			message.error(errorMessage);
		}
		return null;
	}
}

export async function signInWithEmailAndPassword({ email, password }) {
	try {
		return await auth().signInWithEmailAndPassword(email, password);
	} catch (error) {
		const errorCode = error.code;
		const errorMessage = error.message;
		if (errorCode === "auth/wrong-password") {
			message.error("Wrong password.");
		} else {
			message.error(errorMessage);
		}
		return null;
	}
}

export async function fetchSurvey() {
	return await once(keys.survey);
}

export async function fetchQuestions() {
	return await once(keys.questions);
}

export async function fetchAnswers() {
	return await once(keys.answers);
}

export async function fetchResult() {
	return await once(keys.result);
}

export async function fetchOrders() {
	return await once(keys.orders);
}

export async function checkedOrders({ email, checked }) {
	let hashId = btoa(email);
	ref(`${keys.orders}/${hashId}`).update({
		checked: checked
	});
}

export async function fetchUser({ uid }) {
	return await once(`${keys.users}/${uid}`);
}

export async function userCreate({ uid, email }) {
	ref(`${keys.users}/${uid}`).set({
		registrationDate: Date.now(),
		email: email || null
	});
}

export async function userBuy({ email }) {
	let hashId = btoa(email);
	ref(`${keys.orders}/${hashId}`).once("value").then(function(snapshot) {
		const userEmailExist = snapshot.child("email").exists();
		if (!userEmailExist) {
			ref(`${keys.orders}/${hashId}`).set({
				registrationDate: Date.now(),
				email: email,
				checked: false
			});
		}
	});
}

export async function surveyPassed(uid) {
	ref(`${keys.users}/${uid}`).update({
		surveyPassed: Date.now(),
	});
}

export async function surveyFeedback({ uid, feedback }) {
	ref(`${keys.feedback}/${uid}`).update({
		date: Date.now(),
		feedback: feedback
	});
}

export async function onChangeStep({ id, answers, title, type }) {
	var o = {};
	if (title) {
		Object.assign(o, { title });
	}
	
	if (type) {
		Object.assign(o, { type });
	}
	
	if (answers) {
		Object.assign(o, {
			answers: answers.map(({ title, chain, type = AnswerTypes.Title, options = null }) => ({
				title,
				chain,
				type,
				options
			}))
		});
	}
	
	return ref(`${keys.questions}/${id}`).update(o);
}

export async function setResult(questId, result) {
	ref(`result/${questId}`).push(result);
}


// WEBPACK FOOTER //
// ./src/api/index.js